import React from 'react';
import { withRouter } from 'react-router-dom';
import {
    Button,
    Card,
    CardBody,
    CardHeader,
    Container,
    FormGroup,
    Input,
    Table,
} from 'reactstrap';
import './TimeOffRequestIndex.scss';
import { util } from '../Util';
import { ApiRoutes } from '../ApiRoutes';
import { CircularProgress } from '@mui/material';
import { getTenantUserProfile } from '../common/TenantUserProfile';
import { FormLabel } from '../common/forms/FormElements';
import moment from 'moment';
import { MomentDateFormat } from '../MomentDateFormat';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlusCircle } from '@fortawesome/free-solid-svg-icons';
import { Can } from '../Can';
import { AppNavPaths } from '../AppNavPaths';
import TimeOffRequestDisplay from './TimeOffRequestDisplay';

class TimeOffRequestIndex extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            loading: true,
            from: moment()
                .add(-3, 'month')
                .format(MomentDateFormat.DateOnlyUTCHyphenated),
            to: moment()
                .add(3, 'month')
                .format(MomentDateFormat.DateOnlyUTCHyphenated),
            timesheetStatuses: [],
        };
    }

    componentDidMount() {
        this.populateState(true);
    }

    async populateState() {
        const params = this.props.match.params;

        const { id, forManagement } = params;

        const [timeOffReasons, userProfile, timesheetStatuses] =
            await Promise.all([
                util.fetch.js(ApiRoutes.timeOffReasons.all()),
                getTenantUserProfile(),
                util.fetch.js(ApiRoutes.typeAheads.timesheetStatuses()),
            ]);

        const { userPermissions } = userProfile;

        const isAdmin =
            userPermissions &&
            userPermissions.includes('timeoffrequest.accept');

        const isApprover =
            userPermissions &&
            userPermissions.includes('timeoffrequest.approve');

        this.setState(
            {
                id,
                forManagement,
                isAdmin,
                isApprover,
                timeOffReasons,
                anyChanges: false,
                timesheetStatuses,
            },
            () => this.onDateChanged()
        );
    }

    onDateChanged = async () => {
        const { from, to } = this.state;

        const timeOffRequests = await util.fetch.andGetResponse(
            util.fetch.types.post,
            ApiRoutes.timeOffRequests.my(),
            {
                from,
                to,
            }
        );

        this.setState({ loading: false, timeOffRequests });
    };

    onFromChanged = (e) => {
        const from = e.target.value;

        this.setState({ from }, () => this.onDateChanged());
    };

    onToChanged = (e) => {
        const to = e.target.value;

        this.setState({ to }, () => this.onDateChanged());
    };

    onTimeOffRequestClick = (timeOffRequestId) => {
        this.props.history.push(
            `${AppNavPaths.TimeOffRequest}/${timeOffRequestId}`
        );
    };

    render() {
        const { loading, from, to, timeOffRequests } = this.state;

        if (loading) {
            return (
                <CircularProgress color="secondary" variant="indeterminate" />
            );
        }

        return (
            <Container
                className="time-off-request-container p-3 m-3 ml-auto mr-auto"
                fluid={true}
            >
                <Card>
                    <CardHeader className="h3">My Time Off Requests</CardHeader>
                    <CardBody className="d-flex mt-2 ml-2">
                        <FormGroup className="date-entry-container mr-3">
                            <FormLabel text="From" />
                            <Input
                                type="date"
                                value={from}
                                onChange={this.onFromChanged}
                            />
                        </FormGroup>

                        <FormGroup className="date-entry-container">
                            <FormLabel text="To" />
                            <Input
                                type="date"
                                value={to}
                                onChange={this.onToChanged}
                            />
                        </FormGroup>

                        <div className="ml-auto my-auto mr-3">
                            <Can I="edit" a="timeoffrequest">
                                <Button
                                    color="success"
                                    size="lg"
                                    onClick={() =>
                                        this.props.history.push(
                                            `${AppNavPaths.TimeOffRequest}/0`
                                        )
                                    }
                                >
                                    <FontAwesomeIcon
                                        icon={faPlusCircle}
                                        className="mr-1"
                                    />
                                    New request
                                </Button>
                            </Can>
                        </div>
                    </CardBody>
                    <CardBody>
                        {timeOffRequests.length == 0 && (
                            <div>No Time Off Requests Found</div>
                        )}

                        {timeOffRequests.length > 0 && (
                            <Table striped={true}>
                                <thead>
                                    <tr>
                                        <th>Start Date</th>
                                        <th>End Date</th>
                                        <th>Half Day?</th>
                                        <th>Reason</th>
                                        <th>Status</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {timeOffRequests.map((tor) => (
                                        <TimeOffRequestDisplay
                                            key={tor.id}
                                            timeOffRequest={tor}
                                            {...this.state}
                                            onTimeOffRequestClick={
                                                this.onTimeOffRequestClick
                                            }
                                        />
                                    ))}
                                </tbody>
                            </Table>
                        )}
                    </CardBody>
                </Card>
            </Container>
        );
    }
}

export default withRouter(TimeOffRequestIndex);
